import { alphabeticalCompare } from '@cims-online/shared'
import RenderedCell from './components/RenderedCell'
import { Header } from '../types'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { GoogleSheetRecord } from '../GoogleSheetRecord'

export function useColumns(
  headers: Header[] | undefined
): CIMSColumn<GoogleSheetRecord>[] {
  return (headers ?? [])
    .filter(({ visible }) => visible)
    .map((header) => {
      const { formattedValue, id, note } = header
      const fallbackWidth = Math.max(formattedValue.length * 2, 12)
      const withHelp = (length: number) => `calc(${length}ch + 20px)`
      return {
        title: <RenderedCell key={id} {...header} />,
        render: (record) => {
          const cell = record.getCell(header)
          return cell && <RenderedCell key={cell.id} {...cell} />
        },
        help: note,
        width: {
          withoutRecords: withHelp(fallbackWidth),
          withRecords: (records) => {
            const maxCellLength = records.reduce(
              (longest, record) => Math.max(longest, record.maxCellWidth),
              0
            )
            return withHelp(
              Math.max(fallbackWidth, Math.min(maxCellLength, 50))
            )
          },
        },
        sort: {
          with: 'callback',
          onCompare: (a, b) =>
            alphabeticalCompare(
              a.getCell(header),
              b.getCell(header),
              'formattedValue'
            ),
        },
        filter: {
          type: 'search',
          with: 'callback',
          onFilter: (value, record) => {
            const { formattedValue, hyperlink } = record.getCell(header) ?? {}
            const lower = value.toString().toLowerCase()
            const lowerFValue = formattedValue?.toLowerCase()
            const lowerLink = hyperlink?.toLowerCase()
            const lowerNote = note?.toLowerCase()
            return (
              ((!!lowerFValue && lower?.includes(lowerFValue)) ||
                (!!lowerLink && lower?.includes(lowerLink)) ||
                (!!lowerNote && lower?.includes(lowerNote)) ||
                lowerFValue?.includes(lower) ||
                lowerLink?.includes(lower) ||
                lowerNote?.includes(lower)) ??
              false
            )
          },
        },
      }
    })
}
